<script>
  import { onMount, onDestroy } from 'svelte';
  import { get } from 'svelte/store';
  import { saveEgresoDrop } from '../../controllers/egresoDropController.js';
  import { authStore } from '../../lib/authStore';
  import pb from '../../lib/pocketbase';
  
  export let drop; // The drop object
  export let geoField = 'geo_target_ref'; // 'geo_target_ref' or 'geo_delivery_ref'

  let map;
  let marker;
  let mapId = `${geoField}-map-canvas-${drop.id}`;
  let isAdmin = false; // Track if current user is admin

  // Check admin role from localStorage
  function checkAdminRole() {
    const roleData = localStorage.getItem("pb_user_role");
    if (roleData) {
      try {
        const role = JSON.parse(roleData);
        isAdmin = role.descrip === 'Administrador';
      } catch (error) {
        isAdmin = false;
      }
    } else {
      isAdmin = false;
    }
  }

  // Get coordinates from the drop
  function getCoords() {
    const ref = drop[geoField];
    if (ref) {
      const [lat, lng] = ref.split(',').map(parseFloat);
      if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
    }
    // Default location
    return { lat: 14.603032776408446, lng: -90.53445609626046 };
  }

  // Save new coordinates to PocketBase
  async function saveLocation(lat, lng) {
    // Only allow saving if user is admin
    if (!isAdmin) {
      return;
    }
    
    const geo_ref = `${lat},${lng}`;
    try {
      await saveEgresoDrop({ ...drop, [geoField]: geo_ref }, drop.id);
      drop[geoField] = geo_ref; // Update local drop
    } catch (error) {
      console.error('Error saving geo location:', error);
    }
  }

  // Initialize the map
  function initMap() {
    const google = window.google;
    if (!google) {
      console.error('Google Maps not loaded');
      return;
    }
    const coords = getCoords();
    const mapElement = document.getElementById(mapId);
    if (!mapElement) {
      console.error('Map canvas element not found:', mapId);
      return;
    }
    const myLatlng = new google.maps.LatLng(coords.lat, coords.lng);
    const mapOptions = {
      zoom: 16,
      scrollwheel: false,
      center: myLatlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        // You can add custom map styles here if needed
      ],
    };
    map = new google.maps.Map(mapElement, mapOptions);
    marker = new google.maps.Marker({
      position: myLatlng,
      map: map,
      animation: google.maps.Animation.DROP,
      title: geoField === 'geo_delivery_ref' ? 'Ubicación de entrega' : 'Ubicación destino',
      draggable: isAdmin,
    });
    marker.addListener('dragend', () => {
      const position = marker.getPosition();
      saveLocation(position.lat(), position.lng());
    });
    map.addListener('click', (event) => {
      // Only allow clicking to move marker if user is admin
      if (isAdmin) {
        const newPosition = event.latLng;
        marker.setPosition(newPosition);
        saveLocation(newPosition.lat(), newPosition.lng());
      }
    });
  }

  onMount(() => {
    checkAdminRole();
    // Check again after a short delay in case role was still loading
    setTimeout(checkAdminRole, 1000);
    
    if (drop.id && drop.id !== 'new') {
      setTimeout(initMap, 0); // Wait for DOM
    }
  });

  onDestroy(() => {
    if (marker) marker.setMap(null);
    if (map && window.google) window.google.maps.event.clearInstanceListeners(map);
  });
</script>

{#if !drop.id || drop.id === 'new'}
  <div class="my-4 p-4 bg-yellow-50 text-yellow-800 rounded border border-yellow-200 text-center">
    Guarde el drop antes de editar la ubicación.
  </div>
{:else}
  <div class="my-4">
    {#if !isAdmin}
      <div class="mb-2 p-2 bg-red-50 text-red-700 rounded border border-red-200 text-center text-sm">
        Solo los administradores pueden editar las ubicaciones del mapa
      </div>
    {/if}
    <div class="font-semibold text-blueGray-700 mb-1">
      {geoField === 'geo_delivery_ref' ? 'Ubicación de entrega' : 'Ubicación destino'}
    </div>
    <div
      id={mapId}
      class="relative w-full rounded h-72 border"
      style="min-height: 300px;"
    ></div>
  </div>
{/if} 